import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Wordmark from "./Wordmark";

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-base)]">
      <div data-testid="app-loading">
        <Wordmark sizeClass="text-4xl" className="animate-pulse" />
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, requireOnboarded = true }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
